import { useContext } from "react";
import api from "../services/api";
import { message } from "antd";
import { GlobalContext } from "./globalContext";

export type CsaContextType = {
  getResultadosCsa: (anexoId: string) => Promise<any>;
  gerarRelatorioHtml: (cliente_id: string, anexo_id: string) => Promise<any>;
  getRelatoriosIA: (anexoId: string) => Promise<any>;
};

export const useCsaContext = (): CsaContextType => {
  const globalContext = useContext(GlobalContext);

  const getResultadosCsa = (anexoId: string) => {
    globalContext?.incrementLoadingCount();
    return new Promise(async (resolve, reject) => {
      await api
        .get(`/resultados/csa/${anexoId}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          message.error("Erro ao buscar resultados!");
          reject(err);
        })
        .finally(() => globalContext?.decrementLoadingCount());
    });
  };

  const gerarRelatorioHtml = (cliente_id: string, anexo_id: string) => {
    globalContext?.incrementLoadingCount();
    return new Promise(async (resolve, reject) => {
      try {
        const response = await api.post("/resultados/csa/gerar-relatorio", {
          cliente_id,
          anexo_id,
        });
        resolve(response.data);
      } catch (err) {
        message.error("Erro ao gerar relatório técnico.");
        reject(err);
      } finally {
        globalContext?.decrementLoadingCount();
      }
    });
  };
  const getRelatoriosIA = (anexoId: string) => {
    globalContext?.incrementLoadingCount();
    return new Promise(async (resolve, reject) => {
      await api
        .get(`/relatorios-ia/anexo/${anexoId}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => globalContext?.decrementLoadingCount());
    });
  };

  return {
    getResultadosCsa,
    gerarRelatorioHtml,
    getRelatoriosIA,
  };
};
